
import { AfterViewInit, Component, forwardRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { _AbcButtonComponent, _AbcGridComponent } from '@barthauer/abc/ui-components';
import { ActionButton, CategoryViewDefinition } from '../../models/protocol-viewer.model';
import { ProtocolViewerService } from '../../protocol-viewer.service';

@Component({
    selector: 'protocol-category-view',
    templateUrl: './category-view.component.html',
    styleUrls: ['./category-view.component.scss'],
    imports: [forwardRef(() => _AbcGridComponent), _AbcButtonComponent]
})
export class CategoryViewComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('categoryViewComponent') categoryViewComponent: CategoryViewComponent;
  protected categoryViewDefinition: CategoryViewDefinition;
  public actionButtons: ActionButton[];
  public messageInfo: string = '';
  public editCellEnabled: boolean = false;

  constructor(private protocolViewerService: ProtocolViewerService) {
    this.actionButtons = protocolViewerService.actionButtons;
    if (this.actionButtons.length > 1) {
      this.editCellEnabled = true;
    }
  }
  ngOnInit(): void {
    this.categoryViewDefinition = this.protocolViewerService.categoryViewDefinitions.values().next(null).value;
  }

  ngOnDestroy(): void {}

  ngAfterViewInit(): void {}

  public async refreshView(key: string | number): Promise<void> {
    this.categoryViewDefinition = this.protocolViewerService.categoryViewDefinitions.get(key);
  }
}
